import { render } from "./MiCuenta.vue?vue&type=template&id=1273716b&scoped=true"
import script from "./MiCuenta.vue?vue&type=script&lang=js"
export * from "./MiCuenta.vue?vue&type=script&lang=js"

import "./MiCuenta.vue?vue&type=style&index=0&id=1273716b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1273716b"]])

export default __exports__